const icons = {
  deepseek: 'https://p0.ssl.qhimg.com/t110b9a93018e87401f9522c047.png',
  light: 'https://p2.ssl.qhimg.com/t110b9a93017e00215d4cff84d8.png',
  common: 'https://p0.ssl.qhimg.com/t110b9a93019861b03b7b2d4d64.png',
  qwen: 'https://p0.ssl.qhimg.com/t110b9a93011b7b7cccd81ae5f9.png',
  zhinao: 'https://ns.chat.360.cn/zhaomi-so/admin-test-resource/043775fdf97f01541c71bf639b5e6904.png',
}


export const LocalModelConf = {
  "c6c8e5bb06c345c4a33091ee1bfba403": {
    "model": "gemma3:1b",
    "title": "Gemma3 1B",
    "home_recommend": "Gemma3 1B",
    "description": "开源高效单卡AI模型",
    "icon": icons.common
  },
  "4b49a528e8e6407f9c9359e2992a1da2": {
    "model": "gemma3:4b",
    "title": "Gemma3 4B",
    "home_recommend": "Gemma3 4B",
    "description": "开源高效单卡AI模型",
    "icon": icons.common
  },
  "dddd7b3cea0e43cd8becf2828e486901": {
    "model": "gemma3:12b",
    "title": "Gemma3 12B",
    "home_recommend": "Gemma3 12B",
    "description": "开源高效单卡AI模型",
    "icon": icons.common
  },
  "cbe1585639724ae9bda4f3ade0e6628e": {
    "model": "gemma3:27b",
    "title": "Gemma3 27B",
    "home_recommend": "Gemma3 27B",
    "description": "开源高效单卡AI模型",
    "icon": icons.common
  },
  "6f3f6e6829e3433bab1907992e457fe9": {
    "model": "granite3.2-vision:2b",
    "title": "Granite3.2 Vision 2B",
    "home_recommend": "Granite3.2 Vision 2B",
    "description": "紧凑高效的视觉-语言模型，专为视觉文档理解而设计",
    "icon": icons.common
  },
  "10a317118b99478e90540ba8247499ad": {
    "model": "llava:7b",
    "title": "Llava 7B",
    "home_recommend": "Llava 7B",
    "description": "结合了视觉编码器和Vicuna，用于通用视觉和语言理解。",
    "icon": icons.common
  },
  "5e5f06ff969e4e5d9c6a387d54876094": {
    "model": "llava:13b",
    "title": "Llava 13B",
    "home_recommend": "Llava 13B",
    "description": "结合了视觉编码器和Vicuna，用于通用视觉和语言理解。",
    "icon": icons.common
  },
  "0224abf50d754346813588bd5650d49f": {
    "model": "llama3.2-vision:11b",
    "title": "Llama3.2 Vision 11B",
    "home_recommend": "Llama3.2 Vision 11B",
    "description": "Llama 3.2 Vision 是一系列经过指令微调的图像推理生成模型",
    "icon": icons.common
  },
  "c3a7d016b48e48a6828777a75726b19c": {
    "model": "llama3.2-vision:90b",
    "title": "Llama3.2 Vision 90B",
    "home_recommend": "Llama3.2 Vision 90B",
    "description": "Llama 3.2 Vision 是一系列经过指令微调的图像推理生成模型",
    "icon": icons.common
  },
  "b3bebd2791e94f05b38650668d1a7fb6": {
    "model": "zhinao/light-r1:32b-q8",
    "title": "Light-R1 32B int8版本",
    "home_recommend": "Light-R1 32B int8版本",
    "description": "奇虎360首款推理模型，性能超越绝大多数70B模型",
    "icon": icons.zhinao
  },
  "ee69c3f85582443ca8566ef8de59c632": {
    "model": "zhinao/light-r1:32b-fp16",
    "title": "Light-R1 32B 16位版本",
    "home_recommend": "Light-R1 32B 16位版本",
    "description": "奇虎360首款推理模型，性能超越绝大多数70B模型",
    "icon": icons.zhinao
  },
  "58cbc7bf4bd84536bdd4a08e3f0562ad": {
    "model": "zhinao/light-r1:7b-q8",
    "title": "Light-R1 7B int8版本",
    "home_recommend": "Light-R1 7B int8版本",
    "description": "目前最强的 7B 开源数学模型。",
    "icon": icons.zhinao
  },
  "85db822bf4524e55811ac0b130fc695c": {
    "model": "zhinao/light-r1:7b",
    "title": "Light-R1 7B",
    "home_recommend": "Light-R1 7B",
    "description": "目前最强的 7B 开源数学模型。",
    "icon": icons.zhinao
  },
  "6ba90401012749d18bf1c30c35538327": {
    "model": "zhinao/light-r1:32b",
    "title": "Light-R1 32B",
    "home_recommend": "Light-R1 32B",
    "description": "360首款推理模型，性能超越绝大多数70B模型",
    "icon": icons.zhinao
  },
  "f0586123921647eaaecba024217b07a2": {
    "model": "zhinao/light-r1:14b-fp16",
    "title": "Light-R1 14B 16位版本",
    "home_recommend": "Light-R1 14B 16位版本",
    "description": "目前性能最佳的14B数学模型。",
    "icon": icons.zhinao
  },
  "5fe93232b20c45cc82675662f77a5a80": {
    "model": "zhinao/tiny-r1:32b",
    "title": "Tiny-R1 32B",
    "home_recommend": "Tiny-R1 32B",
    "description": "奇虎360首款推理模型，性能超越绝大多数70B模型",
    "icon": icons.zhinao
  },
  "dfae1f77bd1947e9849655b7d277cbee": {
    "model": "zhinao/light-r1:14b",
    "title": "Light-R1 14B",
    "home_recommend": "Light-R1 14B",
    "description": "目前性能最佳的14B数学模型。",
    "icon": icons.zhinao
  },
  "2299a043afb541de84af88ab12281770": {
    "model": "zhinao/light-r1:14b-q8",
    "title": "Light-R1 14B int8版本",
    "home_recommend": "Light-R1 14B int8版本",
    "description": "目前性能最佳的14B数学模型。",
    "icon": icons.zhinao
  },
  "e7841631601a499c91626a8eed974db4": {
    "model": "zhinao/light-r1:7b-fp16",
    "title": "Light-R1 7B 16位版本",
    "home_recommend": "Light-R1 7B 16位版本",
    "description": "目前最强的 7B 开源数学模型。",
    "icon": icons.zhinao
  },
  "c21f4ac3795b4fee891230e7b7709f7a": {
    "model": "deepseek-r1:1.5b",
    "title": "deepseek-r1:1.5b",
    "home_recommend": "deepseek-r1:1.5b",
    "description": "在资源极其有限的环境中提供令人惊讶的推理能力",
    "icon": icons.deepseek
  },
  "502f2241fbb047a5ac976436660d9380": {
    "model": "deepseek-r1:7b",
    "title": "deepseek-r1:7b",
    "home_recommend": "deepseek-r1:7b",
    "description": "DeepSeek系列入门级推理模型",
    "icon": icons.deepseek
  },
  "fdf6d7892254435da3e9016294cbab5f": {
    "model": "deepseek-r1:8b",
    "title": "deepseek-r1:8b",
    "home_recommend": "deepseek-r1:8b",
    "description": "优化推理模型，适合对精确度有较高要求的场景",
    "icon": icons.deepseek
  },
  "3375850166284eb58f1cc8dba66de08e": {
    "model": "deepseek-r1:14b",
    "title": "deepseek-r1:14b",
    "home_recommend": "deepseek-r1:14b",
    "description": "中型推理模型，能够处理复杂的逻辑分析和多步骤推理问题",
    "icon": icons.deepseek
  },
  "e7639be1653d46498c62d91ad3bdaaf2": {
    "model": "deepseek-r1:32b",
    "title": "deepseek-r1:32b",
    "home_recommend": "deepseek-r1:32b",
    "description": "专业级推理模型，在科学计算、逻辑推理和专业领域决策支持方面展现出接近专家水平的能力",
    "icon": icons.deepseek
  },
  "d6aea6841b114f91a7d9093675ed0342": {
    "model": "deepseek-r1:70b",
    "title": "deepseek-r1:70b",
    "home_recommend": "deepseek-r1:70b",
    "description": "旗舰推理模型，在科研分析、系统设计和创新思考方面表现出接近AGI的思维深度。",
    "icon": icons.deepseek
  },
  "64b681b4642540f8949c61e239bb4b42": {
    "model": "deepseek-r1:671b",
    "title": "deepseek-r1:671b",
    "home_recommend": "deepseek-r1:671b",
    "description": "超大规模前沿推理模型，在最复杂的科学、工程和创新领域提供接近人类专家团队水平的解决方案。",
    "icon": icons.deepseek
  },
  "eb4774af31694a97876a415e665e5ded": {
    "model": "qwq:32b",
    "title": "qwq:32b",
    "home_recommend": "qwq:32b",
    "description": "千问(Qwen)系列的推理模型，在处理困难问题时表现尤为出色。",
    "icon": icons.qwen
  },
  "3a46b4160d1140d4a5b0848f5e7efa24": {
    "model": "qwq:latest",
    "title": "qwq:latest",
    "home_recommend": "qwq:latest",
    "description": "千问(Qwen)系列的推理模型，在处理困难问题时表现尤为出色。",
    "icon": icons.qwen
  },
  "4b772c8d117f43a285c0016c8fcd3325": {
    "model": "qwq:32b-q8",
    "title": "qwq:32b-q8",
    "home_recommend": "qwq:32b-q8",
    "description": "千问(Qwen)系列的推理模型，在处理困难问题时表现尤为出色。",
    "icon": icons.qwen
  },
  "57880478ed534d41a48412e04bc5b5dd": {
    "model": "deepseek-r1:8b",
    "title": "deepseek-r1:8b",
    "home_recommend": "deepseek-r1:8b",
    "description": "DeepSeek系列的优化推理模型。它在关键推理节点上进行了参数扩展，在保持类似资源需求的同时，提供了更加稳定和深入的推理表现，特别适合对精确度有较高要求的应用场景。",
    "icon": icons.deepseek
  },
  "ac2646d6eeca46cdbb02c77749a82868": {
    "model": "llama3.3:70b",
    "title": "llama3.3:70b",
    "home_recommend": "llama3.3:70b",
    "description": "最新尖端70B模型。Llama 3.3 70B提供了与Llama 3.1 405B模型相似的性能。",
    "icon": icons.common
  },
  "a14eae1d46e847e38bc295f21b83d4ce": {
    "model": "phi4:14b",
    "title": "phi4:14b",
    "home_recommend": "phi4:14b",
    "description": "Phi-4 是微软推出的一款拥有140亿参数、处于行业领先水平的开源模型。",
    "icon": icons.common
  },
  "13c02f160a2a4b9e9925fa6394bf96a2": {
    "model": "llama3.2:1b",
    "title": "llama3.2:1b",
    "home_recommend": "llama3.2:1b",
    "description": "Meta的Llama 3.2推出小型化版本，包含10亿和30亿参数模型。",
    "icon": icons.common
  },
  "4d9a8a5ee0aa433080cad263edcd8261": {
    "model": "llama3.2:3b",
    "title": "llama3.2:3b",
    "home_recommend": "llama3.2:3b",
    "description": "Meta的Llama 3.2推出了小型化的1B和3B模型。",
    "icon": icons.common
  },
  "53df463e37974741b7bf044203fe2c26": {
    "model": "mistral:7b",
    "title": "mistral:7b",
    "home_recommend": "mistral:7b",
    "description": "Mistral AI发布的7B模型，已更新至0.3版本。",
    "icon": icons.common
  },
  "00a9274bc4444c8695530c73cf60100f": {
    "model": "qwen2.5:0.5b",
    "title": "qwen2.5:0.5b",
    "home_recommend": "qwen2.5:0.5b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个令牌。该模型支持最多128K个令牌，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "ada289d3938f42af8774266b2d673feb": {
    "model": "qwen2.5:1.5b",
    "title": "qwen2.5:1.5b",
    "home_recommend": "qwen2.5:1.5b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个标记。该模型支持最多128K标记，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "c3d0d1025a1a47b781c82e19afa92399": {
    "model": "qwen2.5:3b",
    "title": "qwen2.5:3b",
    "home_recommend": "qwen2.5:3b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个标记。该模型支持最多128K个标记，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "5e6ac89b1af140359140369560dce020": {
    "model": "qwen2.5:7b",
    "title": "qwen2.5:7b",
    "home_recommend": "qwen2.5:7b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个令牌。该模型支持最多128K个令牌，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "9810eb68a39a45f6892a5f617da2aec3": {
    "model": "qwen2.5:14b",
    "title": "qwen2.5:14b",
    "home_recommend": "qwen2.5:14b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个标记。该模型支持最多128K个标记，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "b032c44291b2441b9d4b3083cacbd115": {
    "model": "qwen2.5:32b",
    "title": "qwen2.5:32b",
    "home_recommend": "qwen2.5:32b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个标记。该模型支持最多128K标记，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "790027e92cca4fcaa01c8480980f2074": {
    "model": "qwen2.5:72b",
    "title": "qwen2.5:72b",
    "home_recommend": "qwen2.5:72b",
    "description": "Qwen2.5模型基于阿里巴巴最新的大规模数据集进行预训练，涵盖高达18万亿个令牌。该模型支持最多128K个令牌，并具备多语言支持能力。",
    "icon": icons.qwen
  },
  "229b6faa366643499440e4ad2da53782": {
    "model": "qwen2.5-coder:0.5b",
    "title": "qwen2.5-coder:0.5b",
    "home_recommend": "qwen2.5-coder:0.5b",
    "description": "最新系列的Code-Specific Qwen模型，在代码生成、代码推理和代码修复方面有显著改进。",
    "icon": icons.qwen
  },
  "0e01e27bbe484e96ba45a7dd6a479b05": {
    "model": "qwen2.5-coder:1.5b",
    "title": "qwen2.5-coder:1.5b",
    "home_recommend": "qwen2.5-coder:1.5b",
    "description": "最新系列的Code-Specific Qwen模型，在代码生成、代码推理和代码修复方面有显著改进。",
    "icon": icons.qwen
  },
  "5167ee966ca6450980b919cd4197cb47": {
    "model": "qwen2.5-coder:3b",
    "title": "qwen2.5-coder:3b",
    "home_recommend": "qwen2.5-coder:3b",
    "description": "最新系列的Code-Specific Qwen模型，在代码生成、代码推理和代码修复方面有显著改进。",
    "icon": icons.qwen
  },
  "97de2be89abf43bcbd5513140cdd6e29": {
    "model": "qwen2.5-coder:7b",
    "title": "qwen2.5-coder:7b",
    "home_recommend": "qwen2.5-coder:7b",
    "description": "最新系列的Code-Specific Qwen模型，在代码生成、代码推理和代码修复方面有显著改进。",
    "icon": icons.qwen
  },
  "93c1e9c4acf040788858e47e790f2d6b": {
    "model": "qwen2.5-coder:14b",
    "title": "qwen2.5-coder:14b",
    "home_recommend": "qwen2.5-coder:14b",
    "description": "最新系列的Code-Specific Qwen模型，在代码生成、代码推理和代码修复方面有显著改进。",
    "icon": icons.qwen
  },
  "05dbc1dfa2ab409e9a56da966984abcc": {
    "model": "qwen2.5-coder:32b",
    "title": "qwen2.5-coder:32b",
    "home_recommend": "qwen2.5-coder:32b",
    "description": "最新系列的Code-Specific Qwen模型，在代码生成、代码推理和代码修复方面有显著改进。",
    "icon": icons.qwen
  },
  "04be72e8b1e64aff826178e0929101cf": {
    "model": "gemma2:2b",
    "title": "gemma2:2b",
    "home_recommend": "gemma2:2b",
    "description": "谷歌Gemma 2是一款高性能且高效的模型，提供三种规模：2B、9B和27B。",
    "icon": icons.common
  },
  "121a6fd4a92649ff9abadc9e769a07bf": {
    "model": "gemma2:9b",
    "title": "gemma2:9b",
    "home_recommend": "gemma2:9b",
    "description": "谷歌Gemma 2是一款高性能且高效的模型，提供三种规格：2B、9B和27B。",
    "icon": icons.common
  },
  "acbdf68291834ac2a6a8ac9690630d00": {
    "model": "gemma2:27b",
    "title": "gemma2:27b",
    "home_recommend": "gemma2:27b",
    "description": "Google Gemma 2 是一款高性能且高效的模型，提供三种规模：2B、9B 和 27B。",
    "icon": icons.common
  },
  "5d61d88f3fff443a99a740586707e04e": {
    "model": "codellama:7b",
    "title": "codellama:7b",
    "home_recommend": "codellama:7b",
    "description": "一个大型语言模型，能够利用文本提示生成并讨论代码。",
    "icon": icons.common
  },
  "6a4f047e13ac4f169dbaaf722b65e94f": {
    "model": "codellama:13b",
    "title": "codellama:13b",
    "home_recommend": "codellama:13b",
    "description": "一个大型语言模型，能够利用文本提示生成并讨论代码。",
    "icon": icons.common
  },
  "3ebdd40aff064115a97db474c84b9b5e": {
    "model": "codellama:34b",
    "title": "codellama:34b",
    "home_recommend": "codellama:34b",
    "description": "一个大型语言模型，能够利用文本提示生成并讨论代码。",
    "icon": icons.common
  },
  "72a6a9e503d84e5e84ebb1b8aea11f30": {
    "model": "codellama:70b",
    "title": "codellama:70b",
    "home_recommend": "codellama:70b",
    "description": "一个大型语言模型，能够利用文本提示生成并讨论代码。",
    "icon": icons.common
  },
  "67ea548c5d224ae0b80a0f3e27092358": {
    "model": "mistral-nemo:12b",
    "title": "mistral-nemo:12b",
    "home_recommend": "mistral-nemo:12b",
    "description": "一款由Mistral AI与NVIDIA合作打造的最先进的12B模型，具备128k上下文长度。",
    "icon": icons.common
  },
  "a2e7cdf2dc2c4aa4b2490def2eb00384": {
    "model": "starcoder2:3b",
    "title": "starcoder2:3b",
    "home_recommend": "starcoder2:3b",
    "description": "StarCoder2 是下一代透明训练的开源代码大语言模型，提供三种规模：30亿、70亿和150亿参数。",
    "icon": icons.common
  },
  "5c00bbed1d1941a58a748b56e1ae230e": {
    "model": "starcoder2:7b",
    "title": "starcoder2:7b",
    "home_recommend": "starcoder2:7b",
    "description": "StarCoder2 是下一代透明训练的开放代码大型语言模型，提供三种规模：30亿、70亿和150亿参数。",
    "icon": icons.common
  },
  "51352840e0d74a4ab05dfbff04fc5678": {
    "model": "starcoder2:15b",
    "title": "starcoder2:15b",
    "home_recommend": "starcoder2:15b",
    "description": "StarCoder2 是下一代透明训练的开放代码大型语言模型，提供三种规模：30亿、70亿和150亿参数。",
    "icon": icons.common
  },
  "4c53f652fc9f402fb25ed100ca0c7c57": {
    "model": "deepseek-v3:671b",
    "title": "deepseek-v3:671b",
    "home_recommend": "deepseek-v3:671b",
    "description": "一个强大的专家混合（MoE）语言模型，总参数达6710亿，每个令牌激活370亿参数。",
    "icon": icons.deepseek
  },
  "5b6e499937f14487a21a5b2483b53098": {
    "model": "mixtral:8x7b",
    "title": "mixtral:8x7b",
    "home_recommend": "mixtral:8x7b",
    "description": "一套由Mistral AI提供的开放权重的专家混合模型（MoE），参数规模分别为8x7b和8x22b。",
    "icon": icons.common
  },
  "16d5e67d753c4b2aba3ecc5786d83e28": {
    "model": "mixtral:8x22b",
    "title": "mixtral:8x22b",
    "home_recommend": "mixtral:8x22b",
    "description": "一套由Mistral AI提供的开放权重专家混合模型（MoE），参数规模分别为8x7b和8x22b。",
    "icon": icons.common
  },
  "781ed95a805b4180a0650c44f5b1a9f8": {
    "model": "codegemma:2b",
    "title": "codegemma:2b",
    "home_recommend": "codegemma:2b",
    "description": "CodeGemma 是一系列功能强大且轻量级的模型集合，能够执行多种编程任务，如中间填充代码补全、代码生成、自然语言理解、数学推理以及指令跟随。",
    "icon": icons.common
  },
  "30b1393fa0124f1ea44d9cbe5cc0d198": {
    "model": "codegemma:7b",
    "title": "codegemma:7b",
    "home_recommend": "codegemma:7b",
    "description": "CodeGemma 是一系列功能强大且轻量级的模型集合，能够执行多种编程任务，如中间填充代码补全、代码生成、自然语言理解、数学推理以及指令跟随。",
    "icon": icons.common
  },
  "7d7714996c794d19ad7ebf19d0f3988c": {
    "model": "dolphin-mixtral:8x7b",
    "title": "dolphin-mixtral:8x7b",
    "home_recommend": "dolphin-mixtral:8x7b",
    "description": "基于Mixtral专家混合模型的无审查、8x7b和8x22b微调模型，擅长编码任务。由Eric Hartford创建。",
    "icon": icons.common
  },
  "e752011a78ad4dc5ab4389df6aeec760": {
    "model": "dolphin-mixtral:8x22b",
    "title": "dolphin-mixtral:8x22b",
    "home_recommend": "dolphin-mixtral:8x22b",
    "description": "基于Mixtral专家混合模型的无审查、8x7b和8x22b微调模型，擅长编码任务。由Eric Hartford创建。",
    "icon": icons.common
  },
  "6f0c809de4184a4e836f27fca75121e2": {
    "model": "openthinker:7b",
    "title": "openthinker:7b",
    "home_recommend": "openthinker:7b",
    "description": "一个完全开源的家庭推理模型系列，使用通过提炼DeepSeek-R1得到的数据集构建。",
    "icon": icons.common
  },
  "230860dd0f37496f88a88dee2fea8b2d": {
    "model": "openthinker:32b",
    "title": "openthinker:32b",
    "home_recommend": "openthinker:32b",
    "description": "一个完全开源的家庭推理模型系列，构建于通过提炼DeepSeek-R1得到的数据集之上。",
    "icon": icons.common
  },
  "9ab2a463ada24c2eb54fc88a2f11ebd5": {
    "model": "dolphin3:8b",
    "title": "dolphin3:8b",
    "home_recommend": "dolphin3:8b",
    "description": "海豚3.0 Llama 3.1 8B 🐬是海豚系列指令调优模型的下一代，旨在成为终极通用本地模型，支持编码、数学、代理、函数调用及一般用途。",
    "icon": icons.common
  },
  "ab8a3aa1e14d41e0b9dad0aa8447dd96": {
    "model": "smollm2:135m",
    "title": "smollm2:135m",
    "home_recommend": "smollm2:135m",
    "description": "SmolLM2 是一个紧凑型语言模型系列，提供三种规模：1.35亿、3.6亿和17亿参数。",
    "icon": icons.common
  },
  "3cd387b1588044ceb941ef27934e04a8": {
    "model": "smollm2:360m",
    "title": "smollm2:360m",
    "home_recommend": "smollm2:360m",
    "description": "SmolLM2 是一个紧凑型语言模型系列，提供三种规模：1.35亿、3.6亿和17亿参数。",
    "icon": icons.common
  },
  "b58996bcc2b3447bb36c8773d7de4fe1": {
    "model": "smollm2:1.7b",
    "title": "smollm2:1.7b",
    "home_recommend": "smollm2:1.7b",
    "description": "SmolLM2 是一个紧凑型语言模型系列，提供三种规模：1.35亿、3.6亿和17亿参数。",
    "icon": icons.common
  },
  "308981521bff433c9aa2c9b7e38bf615": {
    "model": "olmo2:7b",
    "title": "olmo2:7b",
    "home_recommend": "olmo2:7b",
    "description": "OLMo 2 是一个新系列的7B和13B模型，训练数据量高达5万亿个标记。这些模型在性能上与同等规模的全开放模型相当或更优，并且在英语学术基准测试中与Llama 3.1等开放权重模型具有竞争力。",
    "icon": icons.common
  },
  "dff30ee5b8414368b98bafc8654d7368": {
    "model": "olmo2:13b",
    "title": "olmo2:13b",
    "home_recommend": "olmo2:13b",
    "description": "OLMo 2 是一个新系列的7B和13B模型，训练数据量高达5万亿个标记。这些模型在性能上与同等规模的全开放模型相当或更优，并且在英语学术基准测试中与Llama 3.1等开放权重模型具有竞争力。",
    "icon": icons.common
  },
  "a2e467d22e50418096a7eaf5e37e1aa3": {
    "model": "mistral-small:22b",
    "title": "mistral-small:22b",
    "home_recommend": "mistral-small:22b",
    "description": "Mistral Small 3在70B以下的“小型”大型语言模型类别中设立了新的基准。",
    "icon": icons.common
  },
  "85acbf2070da47e29ec8a98187ea1190": {
    "model": "mistral-small:24b",
    "title": "mistral-small:24b",
    "home_recommend": "mistral-small:24b",
    "description": "Mistral Small 3 在70B以下的“小型”大型语言模型类别中设立了新的基准。",
    "icon": icons.common
  },
  "1240820b63ba4551b33575442de86224": {
    "model": "dolphin-llama3:8b",
    "title": "dolphin-llama3:8b",
    "home_recommend": "dolphin-llama3:8b",
    "description": "Dolphin 2.9 是由 Eric Hartford 基于 Llama 3 开发的新模型，提供 8B 和 70B 两种规模，具备多种指令、对话及编程技能。",
    "icon": icons.common
  },
  "04d4437efe71433283547e86ca098c6c": {
    "model": "dolphin-llama3:70b",
    "title": "dolphin-llama3:70b",
    "home_recommend": "dolphin-llama3:70b",
    "description": "Dolphin 2.9 是由 Eric Hartford 基于 Llama 3 开发的新模型，提供 8B 和 70B 两种规模，具备多种指令、对话及编程技能。",
    "icon": icons.common
  },
  "61469326228f4b978bf7efad2d8fc287": {
    "model": "yi:6b",
    "title": "yi:6b",
    "home_recommend": "yi:6b",
    "description": "Yi 1.5 是一款高性能的双语语言模型。",
    "icon": icons.common
  },
  "2304e3f94ac54bf5a2e201c504c59b24": {
    "model": "yi:9b",
    "title": "yi:9b",
    "home_recommend": "yi:9b",
    "description": "Yi 1.5 是一款高性能的双语语言模型。",
    "icon": icons.common
  },
  "5e096f88a02d4997890c2a1132fc7dc4": {
    "model": "yi:34b",
    "title": "yi:34b",
    "home_recommend": "yi:34b",
    "description": "Yi 1.5 是一款高性能的双语语言模型。",
    "icon": icons.common
  },
  "b7c3243283c745038813a643c963736c": {
    "model": "hermes3:3b",
    "title": "hermes3:3b",
    "home_recommend": "hermes3:3b",
    "description": "Hermes 3 是 Nous Research 旗舰系列 LLM 的最新版本",
    "icon": icons.common
  },
  "7a9b855aaa194ec1b720cca1df371ac0": {
    "model": "hermes3:8b",
    "title": "hermes3:8b",
    "home_recommend": "hermes3:8b",
    "description": "Hermes 3 是 Nous Research 旗舰系列 LLM 的最新版本",
    "icon": icons.common
  },
  "31d1af9987a840fe8208738b9adb5533": {
    "model": "hermes3:70b",
    "title": "hermes3:70b",
    "home_recommend": "hermes3:70b",
    "description": "Hermes 3 是 Nous Research 旗下 Hermes 系列大型语言模型的最新版本。",
    "icon": icons.common
  },
  "269c04a023324417a61c985bc9a126f7": {
    "model": "hermes3:405b",
    "title": "hermes3:405b",
    "home_recommend": "hermes3:405b",
    "description": "Hermes 3 是 Nous Research 旗舰系列 Hermes 大语言模型的最新版本。",
    "icon": icons.common
  },
  "ab7be3dfdd5747a0818c3b1cf3de5dee": {
    "model": "phi3.5:3.8b",
    "title": "phi3.5:3.8b",
    "home_recommend": "phi3.5:3.8b",
    "description": "一款轻量级AI模型，拥有38亿参数，其性能超越同规模及更大规模的模型。",
    "icon": icons.common
  },
  "a81fc569e49941368fd4741d76f55dae": {
    "model": "granite-code:3b",
    "title": "granite-code:3b",
    "home_recommend": "granite-code:3b",
    "description": "IBM推出的一系列用于代码智能的开源基础模型",
    "icon": icons.common
  },
  "2f00b0877f4344ed9f9f3c6f5899553b": {
    "model": "granite-code:8b",
    "title": "granite-code:8b",
    "home_recommend": "granite-code:8b",
    "description": "IBM推出的一系列用于代码智能的开源基础模型",
    "icon": icons.common
  },
  "b2f04e8de49f4459abfe02ecb543713f": {
    "model": "granite-code:20b",
    "title": "granite-code:20b",
    "home_recommend": "granite-code:20b",
    "description": "IBM推出的一系列用于代码智能的开源基础模型",
    "icon": icons.common
  },
  "d50f282d41d54b91ad0aec5b7c275bec": {
    "model": "granite-code:34b",
    "title": "granite-code:34b",
    "home_recommend": "granite-code:34b",
    "description": "IBM推出的一系列用于代码智能的开源基础模型",
    "icon": icons.common
  },
  "04924b65638946828dbe1f6565b50a9f": {
    "model": "smollm:135m",
    "title": "smollm:135m",
    "home_recommend": "smollm:135m",
    "description": "🪐 一个包含135M、360M和1.7B参数的小型模型家族，基于一个新的高质量数据集进行训练。",
    "icon": icons.common
  },
  "fc9117a7876d4800bc5616fd56c215dc": {
    "model": "smollm:360m",
    "title": "smollm:360m",
    "home_recommend": "smollm:360m",
    "description": "🪐 一系列小型模型，包含1.35亿、3.6亿和17亿参数，基于全新高质量数据集训练而成。",
    "icon": icons.common
  },
  "0b1085160c3b4c2cae3a80fc959bf3b1": {
    "model": "smollm:1.7b",
    "title": "smollm:1.7b",
    "home_recommend": "smollm:1.7b",
    "description": "🪐 一系列小型模型，包含1.35亿、3.6亿和17亿参数，基于一个新的高质量数据集进行训练。",
    "icon": icons.common
  },
  "42b42b00e1914f9ba0d8ce220703d732": {
    "model": "codegeex4:9b",
    "title": "codegeex4:9b",
    "home_recommend": "codegeex4:9b",
    "description": "适用于多种AI软件开发场景的模型，包括代码补全。",
    "icon": icons.common
  },
  "0d346f87aef94b0aa757e7919ca123a1": {
    "model": "qwen2-math:1.5b",
    "title": "qwen2-math:1.5b",
    "home_recommend": "qwen2-math:1.5b",
    "description": "Qwen2数学是一系列基于Qwen2大语言模型构建的专用数学语言模型，其在数学能力上显著超越了开源模型，甚至闭源模型（例如GPT4o）。",
    "icon": icons.qwen
  },
  "78d28e9ddf604b54a38de380826b5999": {
    "model": "qwen2-math:7b",
    "title": "qwen2-math:7b",
    "home_recommend": "qwen2-math:7b",
    "description": "Qwen2数学是一系列基于Qwen2大语言模型（LLMs）构建的专用数学语言模型，其在数学能力上显著超越了开源模型，甚至闭源模型（例如GPT4o）。",
    "icon": icons.qwen
  },
  "4b9080186d774d23857d934a22564aeb": {
    "model": "qwen2-math:72b",
    "title": "qwen2-math:72b",
    "home_recommend": "qwen2-math:72b",
    "description": "Qwen2数学是一系列基于Qwen2大语言模型（LLMs）构建的专门数学语言模型，其在数学能力上显著超越了开源模型，甚至闭源模型（例如GPT4o）。",
    "icon": icons.qwen
  },
  "9ff42dbdf320400d846dcfee00e21b4b": {
    "model": "reflection:70b",
    "title": "reflection:70b",
    "home_recommend": "reflection:70b",
    "description": "一种采用名为反思调优新技术训练的高性能模型，该技术教导大型语言模型检测其推理中的错误并纠正方向。",
    "icon": icons.common
  },
  "0ee5b1510dad49709859a1927cb5e170": {
    "model": "llama3-gradient:8b",
    "title": "llama3-gradient:8b",
    "home_recommend": "llama3-gradient:8b",
    "description": "该模型将LLama-3 8B的上下文长度从8k扩展至超过100万tokens。",
    "icon": icons.common
  },
  "15d7b1b401de474b8e83bd07dbdcedba": {
    "model": "llama3-gradient:70b",
    "title": "llama3-gradient:70b",
    "home_recommend": "llama3-gradient:70b",
    "description": "该模型将LLama-3 8B的上下文长度从8k扩展至超过100万tokens。",
    "icon": icons.common
  },
  "2eff4af2494f474981e6fbe422a8a888": {
    "model": "llama3-chatqa:8b",
    "title": "llama3-chatqa:8b",
    "home_recommend": "llama3-chatqa:8b",
    "description": "一款基于Llama 3的NVIDIA模型，擅长对话式问答（QA）和检索增强生成（RAG）。",
    "icon": icons.common
  },
  "4c61b3758e36422982cffb54e1452aa9": {
    "model": "llama3-chatqa:70b",
    "title": "llama3-chatqa:70b",
    "home_recommend": "llama3-chatqa:70b",
    "description": "一款基于Llama 3的NVIDIA模型，擅长于对话式问答（QA）和检索增强生成（RAG）。",
    "icon": icons.common
  },
  "89978a960bcf4c1799c589c229413904": {
    "model": "granite3.1-dense:2b",
    "title": "granite3.1-dense:2b",
    "home_recommend": "granite3.1-dense:2b",
    "description": "IBM Granite 2B和8B模型是仅处理文本的密集大型语言模型，它们基于超过12万亿个数据标记进行训练，在IBM的初步测试中显示出相较于前代产品在性能和速度上的显著提升。",
    "icon": icons.common
  },
  "faf831aa4ecf4ab3ae0bfb705b9c4ad0": {
    "model": "granite3.1-dense:8b",
    "title": "granite3.1-dense:8b",
    "home_recommend": "granite3.1-dense:8b",
    "description": "IBM Granite 2B和8B模型是仅处理文本的密集大型语言模型，它们基于超过12万亿个数据标记进行训练，在IBM的初步测试中，相较于前代产品在性能和速度上展现了显著提升。",
    "icon": icons.common
  },
  "8b1ae33018f44dffb4300da7e7d5a7d8": {
    "model": "yi-coder:1.5b",
    "title": "yi-coder:1.5b",
    "home_recommend": "yi-coder:1.5b",
    "description": "Yi-Coder是一系列开源代码语言模型，以不到100亿参数实现了顶尖的编程性能。",
    "icon": icons.common
  },
  "9c94b6248826453ab59de186490faa03": {
    "model": "yi-coder:9b",
    "title": "yi-coder:9b",
    "home_recommend": "yi-coder:9b",
    "description": "Yi-Coder是一系列开源代码语言模型，以不到100亿参数实现了顶尖的编程性能。",
    "icon": icons.common
  },
  "0354e76734b04f29b2fc0157b8d1000a": {
    "model": "internlm2:1m",
    "title": "internlm2:1m",
    "home_recommend": "internlm2:1m",
    "description": "InternLM2.5 是一款拥有70亿参数的模型，专为实际应用场景设计，具备卓越的推理能力。",
    "icon": icons.common
  },
  "0f6c7ab254214eaba613f56767a58c81": {
    "model": "internlm2:1.8b",
    "title": "internlm2:1.8b",
    "home_recommend": "internlm2:1.8b",
    "description": "InternLM2.5 是一款拥有70亿参数的模型，专为实际应用场景设计，具备卓越的推理能力。",
    "icon": icons.common
  },
  "0970d87388ff41eea2c5f4b9499ce5e7": {
    "model": "internlm2:7b",
    "title": "internlm2:7b",
    "home_recommend": "internlm2:7b",
    "description": "InternLM2.5是一款拥有70亿参数的模型，专为实际应用场景设计，具备卓越的推理能力。",
    "icon": icons.common
  },
  "6edd6767cfac45979a51cf43d072a160": {
    "model": "internlm2:20b",
    "title": "internlm2:20b",
    "home_recommend": "internlm2:20b",
    "description": "InternLM2.5 是一款拥有70亿参数的模型，专为实际应用场景设计，具备卓越的推理能力。",
    "icon": icons.common
  },
  "5fa4905884254a188a2f9c72792d303b": {
    "model": "nemotron:70b",
    "title": "nemotron:70b",
    "home_recommend": "nemotron:70b",
    "description": "Llama-3.1-Nemotron-70B-Instruct 是由 NVIDIA 定制的大型语言模型，旨在提升 LLM 生成响应用户查询的实用性。",
    "icon": icons.common
  },
  "c9dbe430e92149dba7f50fc48cb9c247": {
    "model": "deepscaler:1.5b",
    "title": "deepscaler:1.5b",
    "home_recommend": "deepscaler:1.5b",
    "description": "Deepseek-R1-Distilled-Qwen-1.5B的微调版本，在仅1.5B参数的情况下，在流行的数学评估中超越了OpenAI的o1-preview表现。",
    "icon": icons.common
  },
  "79b36d763e324436bf1cca8d52a771cb": {
    "model": "granite3-dense:2b",
    "title": "granite3-dense:2b",
    "home_recommend": "granite3-dense:2b",
    "description": "IBM Granite 2B和8B模型旨在支持基于工具的使用场景，并增强检索生成（RAG）功能，从而简化代码生成、翻译和错误修复过程。",
    "icon": icons.common
  },
  "3db459796e28483688595e5b5e4961a9": {
    "model": "granite3-dense:8b",
    "title": "granite3-dense:8b",
    "home_recommend": "granite3-dense:8b",
    "description": "IBM Granite 2B和8B模型旨在支持基于工具的使用场景，并增强检索生成（RAG）功能，从而简化代码生成、翻译和错误修复过程。",
    "icon": icons.common
  },
  "1c0555a87d4d41a1bae517dfa2e199b9": {
    "model": "llama3-groq-tool-use:8b",
    "title": "llama3-groq-tool-use:8b",
    "home_recommend": "llama3-groq-tool-use:8b",
    "description": "Groq推出的一系列模型，代表了开源AI在工具使用/功能调用能力上的重大进步。",
    "icon": icons.common
  },
  "57a90da9d1914776aa216b13ae409e08": {
    "model": "llama3-groq-tool-use:70b",
    "title": "llama3-groq-tool-use:70b",
    "home_recommend": "llama3-groq-tool-use:70b",
    "description": "Groq推出的一系列模型，代表了开源AI在工具使用/功能调用能力上的重大进步。",
    "icon": icons.common
  },
  "9bd3525386f6452e895492e5ad2251de": {
    "model": "deepseek-v2.5:236b",
    "title": "deepseek-v2.5:236b",
    "home_recommend": "deepseek-v2.5:236b",
    "description": "DeekSeek-V2的升级版本，集成了DeepSeek-V2-Chat和DeepSeek-Coder-V2-Instruct的通用与编程能力。",
    "icon": icons.deepseek
  },
  "1f2919e3bdd443e4bde20b7f8c8ae7a0": {
    "model": "granite3-moe:1b",
    "title": "granite3-moe:1b",
    "home_recommend": "granite3-moe:1b",
    "description": "IBM Granite 1B和3B模型是IBM首批专为低延迟使用设计的专家混合（MoE）Granite模型。",
    "icon": icons.common
  },
  "328507a5ced64972982e5ed6b8968d0a": {
    "model": "granite3-moe:3b",
    "title": "granite3-moe:3b",
    "home_recommend": "granite3-moe:3b",
    "description": "IBM Granite 1B和3B模型是IBM首批专为低延迟使用设计的专家混合（MoE）Granite模型。",
    "icon": icons.common
  },
  "6d43ecbb48a84b6e9506a88e3e47187b": {
    "model": "falcon3:1b",
    "title": "falcon3:1b",
    "home_recommend": "falcon3:1b",
    "description": "一系列参数少于100亿的高效AI模型，通过创新训练技术在科学、数学和编程领域表现出色。",
    "icon": icons.common
  },
  "efdd75a72d5d4074a891013feb4471f0": {
    "model": "falcon3:3b",
    "title": "falcon3:3b",
    "home_recommend": "falcon3:3b",
    "description": "一系列参数少于100亿的高效AI模型，通过创新的训练技术，在科学、数学和编程领域表现出色。",
    "icon": icons.common
  },
  "77026338dd9b48a383b8103bb885fcd9": {
    "model": "falcon3:7b",
    "title": "falcon3:7b",
    "home_recommend": "falcon3:7b",
    "description": "一系列参数少于100亿的高效AI模型，通过创新训练技术在科学、数学和编程领域表现出色。",
    "icon": icons.common
  },
  "1d1303263eef48a283166778f974a5f4": {
    "model": "falcon3:10b",
    "title": "falcon3:10b",
    "home_recommend": "falcon3:10b",
    "description": "一系列参数少于100亿的高效AI模型，通过创新的训练技术，在科学、数学和编程领域表现出色。",
    "icon": icons.common
  },
  "e961e9d28a1a4fee9be3cc1abe6f9333": {
    "model": "nous-hermes2-mixtral:8x7b",
    "title": "nous-hermes2-mixtral:8x7b",
    "home_recommend": "nous-hermes2-mixtral:8x7b",
    "description": "来自Nous Research的Nous Hermes 2模型，现已在Mixtral上完成训练。",
    "icon": icons.common
  },
  "b7bba72d9e1340bcbb5eed657bd2c6d4": {
    "model": "shieldgemma:2b",
    "title": "shieldgemma:2b",
    "home_recommend": "shieldgemma:2b",
    "description": "ShieldGemma 是一组经过指令调优的模型，用于根据一系列定义的安全策略评估文本提示输入和文本输出响应的安全性。",
    "icon": icons.common
  },
  "070821a52dc14823b9277dd01c59fc9d": {
    "model": "shieldgemma:9b",
    "title": "shieldgemma:9b",
    "home_recommend": "shieldgemma:9b",
    "description": "ShieldGemma 是一组经过指令调优的模型，用于根据一系列定义的安全策略评估文本提示输入和文本输出响应的安全性。",
    "icon": icons.common
  },
  "cb68899243e7453f9ac43914846a3a10": {
    "model": "shieldgemma:27b",
    "title": "shieldgemma:27b",
    "home_recommend": "shieldgemma:27b",
    "description": "ShieldGemma 是一组经过指令调优的模型，用于根据一系列定义的安全策略评估文本提示输入和文本输出响应的安全性。",
    "icon": icons.common
  },
  "16cc78cb6066496aae5b8964402d1f80": {
    "model": "granite3.1-moe:1b",
    "title": "granite3.1-moe:1b",
    "home_recommend": "granite3.1-moe:1b",
    "description": "IBM Granite 1B和3B模型是IBM设计的长上下文专家混合（MoE）Granite模型，适用于低延迟使用场景。",
    "icon": icons.common
  },
  "d5b8333af3b14a24af988b18be8769e3": {
    "model": "granite3.1-moe:3b",
    "title": "granite3.1-moe:3b",
    "home_recommend": "granite3.1-moe:3b",
    "description": "IBM Granite 1B和3B模型是IBM设计的长上下文专家混合（MoE）Granite模型，适用于低延迟使用场景。",
    "icon": icons.common
  },
  "1bb5d976ab26467aaf27a9f7e6551945": {
    "model": "phi4-mini:3.8b",
    "title": "phi4-mini:3.8b",
    "home_recommend": "phi4-mini:3.8b",
    "description": "Phi-4-mini在多语言支持、推理和数学方面带来了显著增强，现在，期待已久的功能调用特性终于得到支持。",
    "icon": icons.common
  },
  "7a423ec5a5584a0da59f356b2087cc95": {
    "model": "marco-o1:7b",
    "title": "marco-o1:7b",
    "home_recommend": "marco-o1:7b",
    "description": "阿里巴巴国际数字商业集团（AIDC-AI）推出的面向现实世界解决方案的开放大型推理模型。",
    "icon": icons.common
  },
  "0f6d0369929749718d91348f330cee5f": {
    "model": "mathstral:7b",
    "title": "mathstral:7b",
    "home_recommend": "mathstral:7b",
    "description": "MathΣtral：由Mistral AI设计的一个70亿参数模型，专为数学推理与科学发现而打造。",
    "icon": icons.common
  },
  "c6d8bf5fde494b53ba67aa0805dbec0b": {
    "model": "falcon2:11b",
    "title": "falcon2:11b",
    "home_recommend": "falcon2:11b",
    "description": "Falcon2 是一个由 TII 构建的拥有 110 亿参数的因果解码器模型，训练数据超过 5 万亿个标记。",
    "icon": icons.common
  },
  "6383257d48744969a7b1b0dbe77f06dc": {
    "model": "solar-pro:22b",
    "title": "solar-pro:22b",
    "home_recommend": "solar-pro:22b",
    "description": "Solar Pro 预览版：一款拥有220亿参数的高级大型语言模型（LLM），专为适配单GPU设计",
    "icon": icons.common
  },
  "bd3ca68188e048e89dc8fd08dd6e774a": {
    "model": "llama-guard3:1b",
    "title": "llama-guard3:1b",
    "home_recommend": "llama-guard3:1b",
    "description": "Llama Guard 3 是一系列经过微调的模型，专门用于大语言模型（LLM）输入和输出的内容安全分类。",
    "icon": icons.common
  },
  "ca92a86654f242d0a569152d849b7398": {
    "model": "llama-guard3:8b",
    "title": "llama-guard3:8b",
    "home_recommend": "llama-guard3:8b",
    "description": "Llama Guard 3 是一系列经过微调的模型，专门用于大语言模型（LLM）输入和输出的内容安全分类。",
    "icon": icons.common
  },
  "de4f132524ae43559cd4c949fb925ecb": {
    "model": "nuextract:3.8b",
    "title": "nuextract:3.8b",
    "home_recommend": "nuextract:3.8b",
    "description": "一个基于Phi-3的3.8B模型，针对信息抽取任务在私有的高质量合成数据集上进行了微调。",
    "icon": icons.common
  },
  "57fc23eb9cac4845a6b91c93af2c7159": {
    "model": "opencoder:1.5b",
    "title": "opencoder:1.5b",
    "home_recommend": "opencoder:1.5b",
    "description": "OpenCoder 是一个开放且可复现的代码大语言模型家族，包含 15 亿和 80 亿参数规模的模型，支持中英文对话。",
    "icon": icons.common
  },
  "d22f1bcbc89240a2b8430d307ba16406": {
    "model": "opencoder:8b",
    "title": "opencoder:8b",
    "home_recommend": "opencoder:8b",
    "description": "OpenCoder 是一个开放且可复现的代码大语言模型家族，包含1.5B和8B两种规模的模型，支持中英文聊天。",
    "icon": icons.common
  },
  "7029a7481118498f9e8f242bd9450dcc": {
    "model": "tulu3:8b",
    "title": "tulu3:8b",
    "home_recommend": "tulu3:8b",
    "description": "Tülu 3 是一个领先的指令跟随模型系列，由艾伦人工智能研究所提供完全开源的数据、代码和配方。",
    "icon": icons.common
  },
  "202b8af53b28425eab92e11202afe193": {
    "model": "tulu3:70b",
    "title": "tulu3:70b",
    "home_recommend": "tulu3:70b",
    "description": "Tülu 3 是一个领先的指令跟随模型系列，由艾伦人工智能研究所提供完全开源的数据、代码和配方。",
    "icon": icons.common
  },
  "3b7c15fef166472a90ae8a1c77653192": {
    "model": "firefunction-v2:70b",
    "title": "firefunction-v2:70b",
    "home_recommend": "firefunction-v2:70b",
    "description": "基于Llama 3的开源权重函数调用模型，具备与GPT-4o函数调用能力相竞争的实力。",
    "icon": icons.common
  },
  "ca0859f95f5044bca87f0ec51b8388ea": {
    "model": "granite3.2:2b",
    "title": "granite3.2:2b",
    "home_recommend": "granite3.2:2b",
    "description": "Granite-3.2是IBM Granite系列中的一款长上下文AI模型，经过微调以增强其思维能力。",
    "icon": icons.common
  },
  "a155cfe04e6347829fec4b29c7f35e8a": {
    "model": "granite3.2:8b",
    "title": "granite3.2:8b",
    "home_recommend": "granite3.2:8b",
    "description": "Granite-3.2是IBM Granite系列中经过精细调优、具备长上下文处理能力的人工智能模型家族，专为提升思维计算能力而设计。",
    "icon": icons.common
  },
  "c0f77c590f6b42cc8352048d0d566efd": {
    "model": "granite3-guardian:2b",
    "title": "granite3-guardian:2b",
    "home_recommend": "granite3-guardian:2b",
    "description": "IBM Granite Guardian 3.0 2B和8B型号旨在检测提示和/或响应中的风险。",
    "icon": icons.common
  },
  "cf34c41befab4744b9a388050cee2b38": {
    "model": "granite3-guardian:8b",
    "title": "granite3-guardian:8b",
    "home_recommend": "granite3-guardian:8b",
    "description": "IBM Granite Guardian 3.0 2B和8B型号旨在检测提示和/或响应中的风险。",
    "icon": icons.common
  },
  "e0a83ff6904943bbb2504a522846f09d": {
    "model": "r1-1776:70b",
    "title": "r1-1776:70b",
    "home_recommend": "r1-1776:70b",
    "description": "DeepSeek-R1模型的一个版本，经过Perplexity的后训练，以提供无偏见、准确且基于事实的信息。",
    "icon": icons.common
  },
  "57ad3d909da040a0a1d688d830137b7c": {
    "model": "r1-1776:671b",
    "title": "r1-1776:671b",
    "home_recommend": "r1-1776:671b",
    "description": "DeepSeek-R1模型的一个版本，经过Perplexity的后训练，以提供无偏见、准确且基于事实的信息。",
    "icon": icons.common
  },
  "70121d59f42d471aa1a698e8c8167cb2": {
    "model": "sailor2:1b",
    "title": "sailor2:1b",
    "home_recommend": "sailor2:1b",
    "description": "Sailor2 是为东南亚打造的多语言模型，提供1B、8B和20B三种参数规模。",
    "icon": icons.common
  },
  "374f33aff7ee473d99a290f1590d3da1": {
    "model": "sailor2:8b",
    "title": "sailor2:8b",
    "home_recommend": "sailor2:8b",
    "description": "Sailor2 是为东南亚打造的多语言模型，提供1B、8B和20B三种参数规模。",
    "icon": icons.common
  },
  "c59fd3657e994c2697dbc4435e51a504": {
    "model": "sailor2:20b",
    "title": "sailor2:20b",
    "home_recommend": "sailor2:20b",
    "description": "Sailor2 是为东南亚打造的多语言模型，提供1B、8B和20B三种参数规模。",
    "icon": icons.common
  },
  "b3309b698cfb4fb782b1f0bdc5789841": {
    "model": "deepcoder:1.5b",
    "title": "DeepCoder 1.5B",
    "home_recommend": "deepcoder:1.5b",
    "description": "DeepCoder是一个完全开源的14B代码模型，处于O3-mini级别，同时也有1.5B版本可用。",
    "icon": icons.common
  },
  "8934fc7c0d7c47ffb3628dfd0e177b14": {
    "model": "deepcoder:14b",
    "title": "DeepCoder 14B",
    "home_recommend": "deepcoder:14b",
    "description": "DeepCoder是一个完全开源的14B代码模型，处于O3-mini级别，同时也有1.5B版本可用。",
    "icon": icons.common
  },
  "20e19c2ea3514b788c5b3c23d665b032": {
    "model": "deepcoder:latest",
    "title": "DeepCoder 14B",
    "home_recommend": "deepcoder:latest",
    "description": "DeepCoder是一个完全开源的14B代码模型，处于O3-mini级别，同时也有1.5B版本可用。",
    "icon": icons.common
  },
  "c04e65c59ef3482b888a97c1c7af01a2": {
    "model": "cogito:3b",
    "title": "Cogito 3B",
    "home_recommend": "cogito:3b",
    "description": "Cogito v1 预览版是由深度认知(Deep Cogito)开发的一系列混合推理模型，其性能超越了同等规模的最佳开源模型，包括来自LLaMA、DeepSeek和Qwen的同类模型，在大多数标准基准测试中表现更为出色。",
    "icon": icons.common
  },
  "ac112416801a43d3a347b74b6983e815": {
    "model": "cogito:8b",
    "title": "Cogito 8B",
    "home_recommend": "cogito:8b",
    "description": "Cogito v1 预览版是由深度认知(Deep Cogito)开发的一系列混合推理模型，其性能超越了同等规模的最佳开源模型，包括来自LLaMA、DeepSeek和Qwen的同类模型，在大多数标准基准测试中表现更为出色。",
    "icon": icons.common
  },
  "cb227a9c56ca41ca927162c7b14f75ca": {
    "model": "cogito:14b",
    "title": "Cogito 14B",
    "home_recommend": "cogito:14b",
    "description": "Cogito v1 预览版是由深度认知(Deep Cogito)开发的一系列混合推理模型，其性能超越了同等规模的最佳开源模型，包括来自LLaMA、DeepSeek和Qwen的同类模型，在大多数标准基准测试中表现更为出色。",
    "icon": icons.common
  },
  "2dbdd0f77e684b3688194c5d0b464dad": {
    "model": "cogito:32b",
    "title": "Cogito 32B",
    "home_recommend": "cogito:32b",
    "description": "Cogito v1 预览版是由深度认知(Deep Cogito)开发的一系列混合推理模型，其性能超越了同等规模的最佳开源模型，包括来自LLaMA、DeepSeek和Qwen的同类模型，在大多数标准基准测试中表现更为出色。",
    "icon": icons.common
  },
  "51cfb86f1da946669665e64a84ff8cc9": {
    "model": "cogito:70b",
    "title": "Cogito 70B",
    "home_recommend": "cogito:70b",
    "description": "Cogito v1 预览版是由深度认知(Deep Cogito)开发的一系列混合推理模型，其性能超越了同等规模的最佳开源模型，包括来自LLaMA、DeepSeek和Qwen的同类模型，在大多数标准基准测试中表现更为出色。",
    "icon": icons.common
  },
  "7cb4e6217d8e4887ac376f925687b651": {
    "model": "cogito:latest",
    "title": "Cogito 8B",
    "home_recommend": "cogito:latest",
    "description": "Cogito v1 预览版是由深度认知(Deep Cogito)开发的一系列混合推理模型，其性能超越了同等规模的最佳开源模型，包括来自LLaMA、DeepSeek和Qwen的同类模型，在大多数标准基准测试中表现更为出色。",
    "icon": icons.common
  },
  "5c4e212a7b684578bfbd4fe849cd6b68": {
    "model": "phi4:latest",
    "title": "Phi-4 14B",
    "home_recommend": "phi4:latest",
    "description": "Phi-4 是微软推出的一款拥有140亿参数、处于行业领先水平的开源模型。",
    "icon": icons.common
  },
  "931c954964c346a9b97f940e1a9e64e8": {
      "model": "gemma3:1b-it-qat",
      "title": "Gemma3 1B QAT版本",
      "home_recommend": "gemma3:1b-it-qat",
      "description": "开源高效单卡AI模型",
      "icon": icons.common
  },
  "711b8cf758f94124a2b210e63228c770": {
      "model": "gemma3:4b-it-qat",
      "title": "Gemma3 4B QAT版本",
      "home_recommend": "gemma3:4b-it-qat",
      "description": "开源高效单卡AI模型",
      "icon": icons.common
  },
  "29ee0d484204499e9a45d1c8eac5d1f7": {
      "model": "gemma3:12b-it-qat",
      "title": "Gemma3 12B QAT版本",
      "home_recommend": "gemma3:12b-it-qat",
      "description": "开源高效单卡AI模型",
      "icon": icons.common
  },
  "711440a737c2408383977c42f25999be": {
      "model": "gemma3:27b-it-qat",
      "title": "Gemma3 27B QAT版本",
      "home_recommend": "gemma3:27b-it-qat",
      "description": "开源高效单卡AI模型",
      "icon": icons.common
  },
  "aadabde0d9174ab782376c2400bfa130": {
    "model": "granite3.3:2b",
    "title": "Granite3.3 2B",
    "home_recommend": "granite3.3:2b",
    "description": "IBM Granite 2B和8B模型是拥有128K上下文长度的语言模型，它们经过微调以提高推理和指令跟随能力。",
    "icon": icons.common
  },
  "b75014294b6c4f3ab4c06d9459d8d974": {
    "model": "granite3.3:8b",
    "title": "Granite3.3 8B",
    "home_recommend": "granite3.3:8b",
    "description": "IBM Granite 2B和8B模型是拥有128K上下文长度的语言模型，它们经过微调以提高推理和指令跟随能力。",
    "icon": icons.common
  },
  "f9a96a3399bf4b3aadba679c3b35bb30": {
    "model": "granite3.3:latest",
    "title": "Granite3.3 8B",
    "home_recommend": "granite3.3:latest",
    "description": "IBM Granite 2B和8B模型是拥有128K上下文长度的语言模型，它们经过微调以提高推理和指令跟随能力。",
    "icon": icons.common
  },
  "a9fbbad1834147d8babb57102d8274e2": {
      "model": "qwen3:30b-a3b",
      "title": "Qwen3 30B MoE版",
      "home_recommend": "qwen3:30b-a3b",
      "description": "通义千问3 30B MoE版",
      "icon": icons.qwen
  },
  "585196b317054189b8b1aacc772bef5d": {
      "model": "qwen3:235b-a22b",
      "title": "Qwen3 235B MoE版",
      "home_recommend": "qwen3:235b-a22b",
      "description": "通义千问3 235B MoE版",
      "icon": icons.qwen
  },
  "2ba1039c340a46d8847c5a9643127f85": {
      "model": "qwen3:latest",
      "title": "Qwen3 8B",
      "home_recommend": "qwen3:latest",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "96a1aa7251b941a6810b4897f5216639": {
      "model": "qwen3:0.6b",
      "title": "Qwen3 0.6B",
      "home_recommend": "qwen3:0.6b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "d79499b6ee7244c78693a4b2ac97000b": {
      "model": "qwen3:1.7b",
      "title": "Qwen3 1.7B",
      "home_recommend": "qwen3:1.7b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "1857f614a7d2438aa26b02b47e3f5486": {
      "model": "qwen3:4b",
      "title": "Qwen3 4B",
      "home_recommend": "qwen3:4b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "241cf94b4dfe4765b0a183eb83764d12": {
      "model": "qwen3:8b",
      "title": "Qwen3 8B",
      "home_recommend": "qwen3:8b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "34946c67cf994351a7e97f3822edd1a2": {
      "model": "qwen3:14b",
      "title": "Qwen3 14B",
      "home_recommend": "qwen3:14b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "60b267fa3d964d5d9462faf4c6378da1": {
      "model": "qwen3:30b",
      "title": "Qwen3 30B",
      "home_recommend": "qwen3:30b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "3a8335d352a74e77a4ec3227e7739ae6": {
      "model": "qwen3:32b",
      "title": "Qwen3 32B",
      "home_recommend": "qwen3:32b",
      "description": "通义千问 3 系列模型",
      "icon": icons.qwen
  },
  "0617577606be425a917ead43da101b44": {
    "model": "qwen3:235b",
    "title": "Qwen3 235B",
    "home_recommend": "qwen3:235b",
    "description": "通义千问 3 系列模型",
    "icon": icons.qwen
  },
  "8a680628955e4a6192d34e96242a7e35": {
    "model": "mistral-small3.1:24b",
    "title": "mistral-small3.1",
    "home_recommend": "mistral-small3.1:24b",
    "description": "Mistral Small 3.1 升级了最大上下文宽度至 128k。",
    "icon": icons.common
  },
  "dfc7e16c12614a29a935bb8e5cbcbebc": {
      "model": "mistral-small3.1:latest",
      "title": "mistral-small3.1",
      "home_recommend": "mistral-small3.1:lastet",
      "description": "Mistral Small 3.1 升级了最大上下文宽度至 128k。",
      "icon": icons.common
  },
  "39f4b532f5e241fbbd551bccf21ff72d": {
      "model": "phi4-reasoning:14b",
      "title": "phi4-reasoning",
      "home_recommend": "phi4-reasoning:14b",
      "description": "Phi 4 推理版",
      "icon": icons.microsoft
  },
  "0dac1296f91447dfb87c9c198646b930": {
      "model": "phi4-reasoning:plus",
      "title": "phi4-reasoning-plus",
      "home_recommend": "phi4-reasoning-plus",
      "description": "Phi 4 推理增强版",
      "icon": icons.microsoft
  },
  "929a969c92cc4818913c6f629960f03e": {
      "model": "phi4-mini-reasoning:3.8b",
      "title": "phi4-mini-reasoning",
      "home_recommend": "phi4-mini-reasoning:3.8b",
      "description": "Phi 4 Mini 推理版",
      "icon": icons.microsoft
  },
  "52af86926036476a8738e5313fef12ca": {
      "model": "phi4-mini-reasoning:latest",
      "title": "phi4-mini-reasoning",
      "home_recommend": "phi4-mini-reasoning:3.8b",
      "description": "Phi 4 Mini 推理版",
      "icon": icons.microsoft
  },
  "5f49bee9c1294d758adec6450bfc6dfe": {
      "model": "phi4-reasoning:latest",
      "title": "phi4-reasoning",
      "home_recommend": "phi4-reasoning:14b",
      "description": "Phi 4 推理版",
      "icon": icons.microsoft
  },
  "8a680628955e4a6192d34e96242a7e35": {
    "model": "mistral-small3.1:24b",
    "title": "mistral-small3.1",
    "home_recommend": "mistral-small3.1:24b",
    "description": "Mistral Small 3.1 升级了最大上下文宽度至 128k。",
    "icon": icons.common
  },
  "dfc7e16c12614a29a935bb8e5cbcbebc": {
      "model": "mistral-small3.1:latest",
      "title": "mistral-small3.1",
      "home_recommend": "mistral-small3.1:lastet",
      "description": "Mistral Small 3.1 升级了最大上下文宽度至 128k。",
      "icon": icons.common
  },
  "39f4b532f5e241fbbd551bccf21ff72d": {
      "model": "phi4-reasoning:14b",
      "title": "phi4-reasoning",
      "home_recommend": "phi4-reasoning:14b",
      "description": "Phi 4 推理版",
      "icon": icons.microsoft
  },
  "0dac1296f91447dfb87c9c198646b930": {
      "model": "phi4-reasoning:plus",
      "title": "phi4-reasoning-plus",
      "home_recommend": "phi4-reasoning-plus",
      "description": "Phi 4 推理增强版",
      "icon": icons.microsoft
  },
  "929a969c92cc4818913c6f629960f03e": {
      "model": "phi4-mini-reasoning:3.8b",
      "title": "phi4-mini-reasoning",
      "home_recommend": "phi4-mini-reasoning:3.8b",
      "description": "Phi 4 Mini 推理版",
      "icon": icons.microsoft
  },
  "52af86926036476a8738e5313fef12ca": {
      "model": "phi4-mini-reasoning:latest",
      "title": "phi4-mini-reasoning",
      "home_recommend": "phi4-mini-reasoning:3.8b",
      "description": "Phi 4 Mini 推理版",
      "icon": icons.microsoft
  },
  "5f49bee9c1294d758adec6450bfc6dfe": {
      "model": "phi4-reasoning:latest",
      "title": "phi4-reasoning",
      "home_recommend": "phi4-reasoning:14b",
      "description": "Phi 4 推理版",
      "icon": icons.microsoft
  },
  "918907c44cfe488fb1aa8857043509b3": {
      "model": "devstral:24b",
      "title": "devstral",
      "home_recommend": "devstral:24b",
      "description": "用于代码智能体的开源模型",
      "icon": icons.common
  },
  "e2452d8d8a54405e859fe4aef99c0c6b": {
      "model": "devstral:latest",
      "title": "devstral",
      "home_recommend": "devstral:24b",
      "description": "用于代码智能体的开源模型",
      "icon": icons.common
  },
  "03a9cc7928c7431fb6eb7eccee00b1a7": {
      "model": "qwen2.5vl:latest",
      "title": "qwen2.5vl",
      "home_recommend": "qwen2.5vl:7b",
      "description": "千问的旗舰视觉语言模型",
      "icon": icons.qwen
  },
  "232ed6942ded44d69aad844900925458": {
      "model": "qwen2.5vl:3b",
      "title": "qwen2.5vl",
      "home_recommend": "qwen2.5vl:3b",
      "description": "千问的旗舰视觉语言模型",
      "icon": icons.qwen
  },
  "14f162b0719a436cb511743a996b6388": {
      "model": "qwen2.5vl:7b",
      "title": "qwen2.5vl",
      "home_recommend": "qwen2.5vl:7b",
      "description": "千问的旗舰视觉语言模型",
      "icon": icons.qwen
  },
  "03b5c005fe1a4cc6a3075907070f0c3a": {
      "model": "qwen2.5vl:32b",
      "title": "qwen2.5vl",
      "home_recommend": "qwen2.5vl:32b",
      "description": "千问的旗舰视觉语言模型",
      "icon": icons.qwen
  },
  "2cd1fb563e8a49cd8929212fb1ebc450": {
      "model": "qwen2.5vl:72b",
      "title": "qwen2.5vl",
      "home_recommend": "qwen2.5vl:72b",
      "description": "千问的旗舰视觉语言模型",
      "icon": icons.qwen
  },
}